// Copyright (c) 2025 WiseTime. All rights reserved.

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../app/store"
import { TimesheetFieldConfig } from "../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

export type TimesheetFieldConfigsState = {
  [configHash: string]: TimesheetFieldConfig.AsObject,
}

export type State = {
  timesheetFieldConfigs: TimesheetFieldConfigsState,
}

export const initialState: State = {
  timesheetFieldConfigs: {},
}

export type SetTimesheetFieldConfigsPayload = {
  configs: TimesheetFieldConfig.AsObject[],
}

export const slice = createSlice({
  name: "timesheetFields",
  initialState,
  reducers: {
    setTimesheetFieldConfigs: (state, action: PayloadAction<SetTimesheetFieldConfigsPayload>) => {
      const { configs } = action.payload
      configs.forEach(config => {
        if (config.configRef) {
          state.timesheetFieldConfigs[config.configRef.configHash] = config
        }
      })
    },
  },
})

export const {
  setTimesheetFieldConfigs,
} = slice.actions

export const selectTimesheetFieldConfigs = (state: RootState): TimesheetFieldConfigsState =>
  state.timesheetFields.timesheetFieldConfigs

export default slice.reducer
